import React, { useEffect, useState } from 'react';
import { ToastProps } from './Toaster.types';
import './Toast.scss';
import { IoCheckmarkCircle, IoCloseCircle, IoInformationCircle, IoWarning, IoClose } from 'react-icons/io5';

export const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
    const [isExiting, setIsExiting] = useState(false);
    const { id, type, message, duration, autoClose } = toast;

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (autoClose) {
            timer = setTimeout(() => {
                setIsExiting(true);
                setTimeout(onClose, 300); // Attendre la fin de l'animation avant de fermer
            }, duration);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [id, duration, onClose, autoClose]);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(onClose, 300);
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <IoCheckmarkCircle size={24} />;
            case 'error':
                return <IoCloseCircle size={24} />;
            case 'info':
                return <IoInformationCircle size={24} />;
            case 'warning':
                return <IoWarning size={24} />;
            default:
                return null;
        }
    };

    return (
        <div className={`toast toast-${type} ${isExiting ? 'toast-exit' : 'toast-enter'}`}>
            <div className="toast-icon">{getIcon()}</div>
            <div className="toast-content">
                <div className="toast-message">{message}</div>
            </div>
            <button className="toast-close" onClick={handleClose}>
                <IoClose size={18} />
            </button>
        </div>
    );
};
